<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import TeatroPassEdit from "./TeatroPassEdit.svelte";

    const tableColumns = [
        {key: 'lastname', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'expire_at', title: 'EXPIRE', sortable: true, class: 'hidden-xs'},
        {key: 'created_at', title: 'CREATED', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    const pageHeaderControls = [
        {id: 'create', name: 'NEW PASS', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let list = null;
    let listTotal = null;
    let page = 1;
    let search = {
        limit: itemsPerPage[0]
    };
    let selectedId = null;
    let passId = null;


    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            listTotal = ~~result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.teatro.index, search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const onCreate = () => {
        passId = 0;
    }

    const onEdit = (item) => {
        selectedId = item.id;
        passId = item.id;
    }

    const closeEdit = param => {
        passId = null;
        if (!param) {
            return;
        }
        let item = list.find(x => x.id === param.id);
        if (!item) {
            list = [param, ...list];
        } else {
            Object.keys(param).map(key => {
                item[key] = param[key];
            });
            list = list;
        }
    }

    const onDelete = (item) => {
        let name = (item.lastname + ' ' + item.firstname).trim();
        Alert.delete("Delete Pass", `You are about to delete pass from "${name}".\nAre you sure?`, () => deletePass(item.id));
    }

    const deletePass = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            Notifier.showMessage("Pass deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.teatro.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Teatro Passes" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>
<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-6 col-lg-4 col-md-4 form-group-md form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.name }" on:change={ onSearch }
                   placeholder="name">
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.email }" on:change={ onSearch }
                   placeholder="email">
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>CLEAR</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>SEARCH</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">view { item } / page</option>
            {/each}
        </select>
    </div>
    {#if list && list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Members: <strong>{ listTotal }</strong></span>
            <span class="listing-info hidden-xs">Page: <strong>{ page }</strong></span>
        </div>
    {/if}
</div>

{#if list}
    {#if list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td>
                        <button class="btn is-link p-0" on:click="{ () => onEdit(item) }">
                            { item.lastname } { item.firstname }
                        </button>
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        {#if item.expire_at}
                            { formatDate(item.expire_at, 'd-m-y') }
                        {/if}
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        { formatDate(item.created_at, 'd-m-y') }
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column">
                            <button class="btn btn-action" title="delete member" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ listTotal }" page="{ page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            No passes found.
        </div>
    {/if}
{/if}

{#if passId != null}
    <TeatroPassEdit {passId} closeCallback={closeEdit}/>
{/if}
